module.exports = __webpack_public_path__ + "img/cns_email_mac7.6acef37c.png";